module.exports = __webpack_public_path__ + "img/specx.47d23cf2.png";